import type { DirectiveBinding, ObjectDirective } from 'vue'

interface ClickOutsideElement extends HTMLElement {
    __vueClickOutsideHandler__?: (event: Event) => void
}

export const clickOutside: ObjectDirective<ClickOutsideElement> = {
    beforeMount(el: ClickOutsideElement, binding: DirectiveBinding) {
        const handler = (event: Event) => {
            const target = event.target as Node
            if (!el.contains(target) && el !== target) {
                binding.value(event)
            }
        }

        el.__vueClickOutsideHandler__ = handler
        document.addEventListener('click', handler, true)
    },
    unmounted(el: ClickOutsideElement) {
        if (el.__vueClickOutsideHandler__) {
            document.removeEventListener('click', el.__vueClickOutsideHandler__, true)
        }
    }
}